export const TEMPLATES_API = '/api/dashboard/customer/membership/course/page-templates'
